import { BarChart } from './BarChart';
import { EChartsBarChartHorizontal } from './EChartsBarChartHorizontal';
import { EChartsBarChartHorizontalDots } from './EChartsBarChartHorizontalDots';
import { EChartsBarChartVertical } from './EChartsBarChartVertical';
import { EChartsBarChartVerticalDots } from './EChartsBarChartVerticalDots';
import { EChartsPieChart } from './EChartsPieChart';
import { PieChart } from './PieChart';
import { StatesHeatMap } from './StatesHeatMap';

export const CHARTS = {
  Bar: BarChart,
  Pie: PieChart,
  States: StatesHeatMap,
};

export type ChartType = keyof typeof CHARTS;

export const CHARTS_V2 = {
  Bar_Vertical_Dots: EChartsBarChartVerticalDots,
  Bar_Horizontal_Dots: EChartsBarChartHorizontalDots,
  Bar_Vertical: EChartsBarChartVertical,
  Bar_Horizontal: EChartsBarChartHorizontal,
  Pie: EChartsPieChart,
  States: StatesHeatMap,
};

export type ChartType_V2 = keyof typeof CHARTS_V2;

export type { CommonChartProps } from './chartsCommons';
